// CheckoutForm.tsx
import React from 'react';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MenuItem } from '@mui/material';
import { INSTITUTIONS } from '../../../shared/data/institutions';
import { PickerValue } from '@mui/x-date-pickers/internals';

interface RegistrationFormProps {
    state: {
        firstName: string;
        lastName: string;
        email: string;
        phoneNumber: string;
        dateOfBirth: PickerValue;
        postSecondaryInstitution: string;
        otherInstitution: string;
        joiningAs: string;
        otherJoiningAs: string;
        questions: string;
    };
    handleFieldChange: (field: string, value: string | PickerValue) => void;
}


export const RegistrationForm: React.FC<RegistrationFormProps> = ({
    state,
    handleFieldChange,
}) => {
    return (
        <form className="checkout-form">
            <div className="name sm:flex justify-between sm:gap-5">
                <TextField
                    className="w-full sm:basis-[49%]"
                    label="First Name*"
                    value={state.firstName}
                    onChange={(e) => handleFieldChange('firstName', e.target.value)}
                />
                <TextField
                    className="w-full sm:basis-[49%]"
                    label="Last Name*"
                    value={state.lastName}
                    onChange={(e) => handleFieldChange('lastName', e.target.value)}
                />
            </div>
            <div className="pt-[3%]">
                <TextField
                    className="w-full"
                    label="Email Address*"
                    value={state.email}
                    onChange={(e) => handleFieldChange('email', e.target.value)}
                />
            </div>
            <div className="pt-[3%]">
                <TextField
                    className="w-full"
                    label="Phone Number*"
                    value={state.phoneNumber}
                    onChange={(e) => handleFieldChange('phoneNumber', e.target.value)}
                />
            </div>
            <div className='pt-[3%]'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={state.dateOfBirth} className='w-full' label="Date of Birth*" onChange={(val) => handleFieldChange('dateOfBirth', val)} />
                </LocalizationProvider>
            </div>
            <div className='pt-[3%]'>
                <TextField
                    className={`w-full`}
                    value={state.postSecondaryInstitution}
                    select
                    label="Post Secondary Institution*"
                    onChange={(e) => handleFieldChange('postSecondaryInstitution', e.target.value)}
                >
                    {INSTITUTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextField>
            </div>
            {state.postSecondaryInstitution === "Other" && (
                <div className="pt-[3%]">
                    <TextField
                        className="w-full"
                        label="Please specify your institution*"
                        value={state.otherInstitution}
                        onChange={(e) => handleFieldChange("otherInstitution", e.target.value)}
                    />
                </div>
            )}
            <div className="pt-[3%]">
                <TextField
                    className="w-full"
                    value={state.joiningAs}
                    select
                    label="Will you be joining us as a*"
                    onChange={(e) => handleFieldChange("joiningAs", e.target.value)}
                >
                    {["Student", "Parent", "Other"].map((role) => (
                        <MenuItem key={role} value={role}>
                            {role}
                        </MenuItem>
                    ))}
                </TextField>
            </div>
            {state.joiningAs === "Other" && (
                <div className="pt-[3%]">
                    <TextField
                        className="w-full"
                        label="Please specify who you're joining as*"
                        value={state.otherJoiningAs}
                        onChange={(e) => handleFieldChange("otherJoiningAs", e.target.value)}
                    />
                </div>
            )}
            <div className="pt-[3%]">
                <TextField
                    className="w-full"
                    label="Any specific questions? (Optional)"
                    value={state.questions}
                    multiline
                    rows={3}
                    onChange={(e) => handleFieldChange("questions", e.target.value)}
                />
            </div>
        </form>
    );
};
